import API from "../api";
export default {
  namespaced: true,
  state: {
    itemsLegacyImportation: {
      data: [],
      total_count: 0
    },
    itemsStatusLegacyImportation: [],
    itemsTypeLegacyImportation: []
  },
  mutations: {
    setItemsLegacyImportation(state, payload) {
      state.itemsLegacyImportation = payload;
    },
    setItemsStatusLegacyImportation(state, payload) {
      state.itemsStatusLegacyImportation = payload;
    },
    setItemsTypeLegacyImportation(state, payload) {
      state.itemsTypeLegacyImportation = payload;
    }
  },
  actions: {
    async requestItemsLegacyImportation({ commit }, payload) {
      const { data } = await API.getItemsLegacyImportation(payload);
      commit("setItemsLegacyImportation", data);
      return data;
    },
    async requestItemsStatusLegacyImportation({ commit }, payload) {
      const { data } = await API.getItemsStatusLegacyImportation(payload);
      commit("setItemsStatusLegacyImportation", data);
      return data;
    },
    async requestItemsTypeLegacyImportation({ commit }, payload) {
      const { data } = await API.getItemsTypeLegacyImportation(payload);
      commit("setItemsTypeLegacyImportation", data);
      return data;
    },
    async requestCancelLegacyImportation(context, payload) {
      const { data } = await API.putCancelLegacyImportation(payload);
      return data;
    },
    async requestAutoCompleteEconomicGroup(context, payload) {
      const { data } = await API.getGroupEconomic(payload);
      return data;
    },
    async requestNewLegacyImportation(context, payload) {
      const { data } = await API.postLegacyImportation(payload);
      return data;
    }
  },
  modules: {}
};
